import { apolloApi } from "@/shared/api";

export async function teamPicksLoader({ teamId }: { teamId: number }) {
  const { pickAssets } = await apolloApi.getPickAssets({ teamId });
  return pickAssets;
}
